import { Fragment, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import WhatsAppButton from '../WhatsAppButton';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../ui/breadcrumb';

/* Layout commun aux pages de service : header + footer existants,
   fil d'Ariane visible, et espace haut pour le header fixe.
   `trail` = [{ name, to }] ; le dernier élément est la page courante. */

const ServicePageLayout = ({ trail = [], children }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <>
      <Header />

      <main className="pt-24 lg:pt-28">
        {/* Fil d'Ariane visible */}
        <div className="container-custom">
          <Breadcrumb className="py-4">
            <BreadcrumbList>
              {trail.map((item, idx) => {
                const isLast = idx === trail.length - 1;
                return (
                  <Fragment key={item.name}>
                    <BreadcrumbItem>
                      {isLast || !item.to ? (
                        <BreadcrumbPage className="text-slate-700">{item.name}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink asChild className="text-slate-500 hover:text-blue-600">
                          <Link to={item.to}>{item.name}</Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {children}
      </main>

      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default ServicePageLayout;
